
const LandingPageSeller = () => {



    return (

        <div>
           Dobro dosli na sellera
    </div>

    );
};

export default LandingPageSeller;
